export default "__VITE_ASSET__73910711__"